import React, { useState } from 'react';
import { useSpring, animated } from 'react-spring';
import '../styles.css';
import { useDispatch } from 'react-redux';
import { GOTO_PAGE } from '../../HOME/REDUX/actions';
import BackButton from '../COMPONENTS/BackButton';
import { GradientBackground } from '../COMPONENTS/Background';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import _ from 'lodash';
import { SIZE_PAGE } from '../../HOME/const';
import * as f from '../logic';
import { SET_SKILL } from '../REDUX/actions';
import RobotIcon from '../COMPONENTS/RobotIcon';
import { PN_RED, PN_GREEN, PN_YELLOW, PN_INDIGO } from '../../PN/const';

const SkillPage = () => {
  const dispatch = useDispatch();
  const [skill, setSkill] = useState(0);

  const handleSkill = () => {
    dispatch({ type: SET_SKILL, skill });
    dispatch({ type: GOTO_PAGE, payload: { page: SIZE_PAGE } });
  };

  const pulseString = useSpring({
    to: { transform: `scale(${skill ? 0.75 : 1})` },
    onRest: () => skill && handleSkill(),
    config: { duration: 200 },
  });

  const skills = ['Week', 'Average', 'Strong', 'Killer'];
  const colors = [PN_GREEN, PN_YELLOW, PN_INDIGO, PN_RED];

  return (
    <div className="page-root">
      <div className="ms-logo-title">{f.renderTitle('AI', 'mt-title pt-title')}</div>
      <div className="pt-page" style={{ backgroundImage: GradientBackground }}>
        {_.map([1, 2, 3, 4], op => {
          const style = op === skill ? pulseString : {};
          return (
            <animated.div key={op} className="pt-start-option pt-option" style={style} onClick={() => setSkill(op)}>
              <>
                <RobotIcon width="50px" color={colors[op - 1]} style={{ gridArea: '1/1', marginRight: '15px' }} />
                {f.renderTitle(skills[op - 1], 'mt-tilte pt-title pt-text-option')}
              </>
            </animated.div>
          );
        })}
        <BackButton />
        <HomeButton />
      </div>
    </div>
  );
};

export default SkillPage;
